export enum ChartValuesType {
  Integer = 'integer',
  Percentage = 'percentage',
  PercentageFloat = 'percentageFloat',
  Currency = 'currency',
  Float = 'float',
}
